module.exports = __webpack_public_path__ + "img/001.41310a5b.png";